import hmacSHA1 from 'crypto-js/hmac-sha1';

export const isValidDeviceId = deviceId => deviceId.indexOf('-Z-') !== -1;

const randomInt = (a, b) => {
  const ceilA = Math.ceil(a);
  const floorB = Math.floor(b);

  return Math.floor(Math.random() * (floorB - ceilA)) + ceilA;
};

export const fixDeviceId = deviceId => `${deviceId}-Z-${randomInt(0, 1e6)}`;

const generateDeviceId = () => {
  const prefix = 'deviceid';
  const uniqueID = hmacSHA1(randomInt(0, 1e6), randomInt(0, 1e6).toString());
  const salt = Date.now();
  const suffix = randomInt(0, 1e6);

  return `${prefix}-${uniqueID}-${salt}-Z-${suffix}`;
};

export default generateDeviceId;
